export default __webpack_public_path__ + "static/media/70_Boule_mob.5b215c9e.svg";